<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import store from "@/store";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import {siteConfig} from "@/utils/config";

const prop = defineProps(['show', 'product'])
const emit = defineEmits(['closed', 'success'])
const changeProduct = ref({})
const showProduct = ref(false)
const type = computed(() => store.state.coupon)
const logo = computed(() => {
  let _logo = "";
  if (type.value === "nakebao") {
    _logo = changeProduct.value.logo
  } else {
    _logo = require(`@/assets/images/${type.value}/logo2.png`)
  }
  return _logo
})
const account = computed(() => store.state.account)
const loading = ref(false)
const rechargeMobile = ref("")
const sendSms = ref(false)
const realDialog = ref(false)
const couponName = computed(() => {
  let text = type.value && siteConfig[type.value].name ? siteConfig[type.value].name : ""
  switch (type.value) {
    case "nakebao":
      text = changeProduct.value.plate
      break;
  }
  return text
})
const order_from = computed(() => store.state.orderFrom)
onMounted(() => {
  store.commit("getCoupon")
  store.dispatch("getAccounts")
  showProduct.value = prop.show
  changeProduct.value = prop.product
  store.commit("getOrderFrom")
})
const qiaopaiCard = ref("")
const qiaopaiType = ref(true)
const changeQuery = () => {
  if (changeProduct.value.from_items === "qiaopai" && rechargeMobile.value) {
    //查询是否是四川壳牌会员
    new axiosApi({
      encode: 'coupon',
      method: "life/qiaopaiRegisterUserQuery",
      body: {
        mobile: rechargeMobile.value
      }
    }).send((res) => {
      if (res.message.code === "000") {
        qiaopaiCard.value = res.data.CardNumber
        qiaopaiType.value = true
      } else {
        ElMessage.error("壳牌加油券只能是四川注册会员才能兑换！")
        qiaopaiType.value = false
      }
    })
  }
}

const pay = () => {
  //判断是否输入手机号
  if (!/^1[2-9]\d{9}$/.test(rechargeMobile.value)) {
    return ElMessage.error({message: `请输入${couponName.value}会员手机号`})
  }
  if (!qiaopaiCard.value && changeProduct.value.from_items === "qiaopai") {
    return ElMessage.error("壳牌会员校验中，请稍等……")
  }
  if (!qiaopaiType.value) {
    return ElMessage.error("壳牌加油券只能是四川注册会员才能兑换！")
  }
  if (!sendSms.value) {
    sendSms.value = true;
    return;
  }

  loading.value = true
  sendSms.value = false;
  new axiosApi({
    encode: "coupon",
    method: "life/pay",
    body: {
      cust_id: account.value.cust_id,
      product: changeProduct.value.third_id,
      plate: changeProduct.value.from_items,
      account: rechargeMobile.value,
      type: "scal",
      order_from: order_from.value,
      qiaopai: qiaopaiCard.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7401") {
      return ElMessage.error({message: res.message.content})
    } else if (res.message.code === '7401') {
      realDialog.value = true;
      return
    }
    showProduct.value = false
    emit("success")
    store.commit("setOrder", res.data)
  }, () => loading.value = false)
}

const luckin_tips = require("@/assets/images/luckin/luckin-tips.png")

</script>

<template>
  <el-drawer direction="btt" v-model="showProduct" :with-header="false" class="product-drawer" size="460"
             @closed="emit('closed')">
    <div class="recharge-drawer">
      <div class="product-items">
        <div class="logo" :class="type">
          <el-image :src="logo"/>
        </div>
        <div class="product-name">
          <h3 v-if="type !== 'nakebao'">{{ changeProduct.goods_name }}</h3>
          <h3 v-else>{{ changeProduct.plate }}{{
              changeProduct.goods_name
            }}{{ changeProduct.remark.num > 1 ? `${changeProduct.remark.num}个` : '' }}</h3>
          <div class="miles-ites">
            <p class="miles">{{ changeProduct.mileTypes.scal.total }}</p>
            <p class="unit">里程</p>
          </div>
          <div class="price-active" v-if="changeProduct.active_goods">
            <div v-if="type === 'nakebao'">
              <span class="price-tips">赠</span>
              <span v-for="act in changeProduct.active_goods" class="active_goods_numbers">{{ act.name }}<b
                  class="active_goods_number">{{ act.number }}个</b></span>
            </div>
            <div v-else-if="type === 'luckin'">
              <el-image :src="luckin_tips" style="height: 15px"/>
            </div>
          </div>
        </div>
      </div>
      <el-card shadow="never">
        <div class="recharge-items">
          <div class="recharge-items-its">充值账号</div>
          <div class="recharge-items-its recharge-items-value">
            <span style="font-size: .7rem;color: var(--el-color-warning);display: block;margin-bottom: 10px"
                  v-if="couponName !== '瑞幸咖啡'">输入的手机号将自动注册为{{
                couponName
              }}会员</span>
            <el-input :placeholder="`请输入${couponName}会员手机号`" clearable v-model="rechargeMobile"
                      @blur="changeQuery"/>
          </div>
        </div>
        <div style="height: 6px;" v-if="couponName === '瑞幸咖啡'"></div>
        <div v-if="couponName === '瑞幸咖啡'" style="font-size: 10px;color: rgba(255, 141, 26, 1);text-align: justify;vertical-align: top;">
          若填写的充值手机号未注册瑞幸咖啡会员，兑换成功后系统将自动注册为瑞幸咖啡会员并完成充值。
        </div>
      </el-card>
      <el-card shadow="never">
        <div class="recharge-items">
          <div class="recharge-items-its">可用里程</div>
          <div class="recharge-items-its">{{ account.balance_miles }}</div>
        </div>
        <div class="recharge-items">
          <div class="recharge-items-its">支付里程</div>
          <div class="recharge-items-its">{{ changeProduct.mileTypes.scal.total }}</div>
        </div>
      </el-card>
      <div class="recharge-btn">
        <el-button round type="danger" size="large" color="#E31D1A" @click="pay" :loading="loading"
                   :disabled="parseInt(changeProduct.mileTypes.scal.total) > parseInt(account.balance_miles)">{{
            parseInt(changeProduct.mileTypes.scal.total) > parseInt(account.balance_miles) ? '可用里程不足' : '立即兑换'
          }}
        </el-button>
      </div>
    </div>
  </el-drawer>
  <send-sms-components :show="sendSms" :login-account="account" v-if="sendSms" @sends="pay"/>
  <real-name :dialog="realDialog" @changeModel="realDialog=false" v-if="realDialog"/>
</template>

<style lang="less">
.product-drawer {
  border-radius: 20px 20px 0 0;
}

.recharge-drawer {
  .product-items {
    display: flex;

    .logo {
      flex-basis: 65px;
      width: 65px;
      height: 65px;
      margin-right: 10px;
      background: #E3E3E3;
      border-radius: 15px;
      padding: 10px;

      .el-image {
        width: 65px;
      }

      &.nakebao {
        background: #BFE8BA;
      }
    }

    .product-name {
      line-height: 1.75;

      .miles-ites {
        display: flex;
        align-items: flex-end;
        height: 25px;
        line-height: 25px;
        margin-top: 15px;
        //align-items: center;

        .miles {
          color: #E31D1A;
          font-size: 1.5rem;
          margin-right: 5px;
        }

        .unit {
          font-size: .85rem;
          margin-bottom: -3px;
        }
      }
    }
  }

  .el-card {
    margin: 15px auto;
    border-radius: 12px;

    .recharge-items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px auto;

      & + .recharge-items {
        padding-top: 10px;
        border-top: var(--el-border);
      }

      .recharge-items-its {

        &.recharge-items-value {
          width: 65%;

        }

        .el-input__wrapper {
          background-color: #e5e5e5;
          height: 30px;
          box-shadow: none;
        }
      }
    }
  }

  .recharge-btn {
    width: 97%;
    margin: auto;

    .el-button {
      width: 100%;
    }
  }
}

.price-active {
  line-height: 1.4;
  margin-top: 10px;

  .price-tips {
    background: linear-gradient(100deg, #F66E3E 0%, #F3AB41 100%);
    border-radius: 50%;
    color: #ffffff;
    font-size: .7rem;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    display: inline-block;
  }

  .active_goods_numbers {
    padding: 5px;
    font-size: .8rem;

    .active_goods_number {
      padding-left: 5px;
      color: #F3AB41;
    }
  }
}
</style>
